<template>
  <page-outline :title="$t('Webheader.verifications')">
    <template slot="pageContent">
      <b-row>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="siren"
            :inputLabel="$t('verifications.lblSIREN')"
            :placeholderValue="$t('verifications.placeHSIREN')"
            :mandatoryErrorIndicator="sirenError"
            :regexpErrorIndicator="sirenRegexpError">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="siret"
            :inputLabel="$t('verifications.lblSIRET')"
            :placeholderValue="$t('verifications.placeHSIRET')"
            :mandatoryErrorIndicator="siretError"
            :regexpErrorIndicator="siretRegexpError">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="vatNumber"
            :inputLabel="$t('verifications.lblVATNumber')"
            :placeholderValue="$t('verifications.placeHVATNumber')"
            :mandatoryErrorIndicator="vatNumberError"
            :regexpErrorIndicator="vatNumberRegexpError">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="socialReason"
            :inputLabel="$t('verifications.lblSocialReason')"
            :placeholderValue="$t('verifications.placeHSocialReason')"
            :mandatoryErrorIndicator="socialReasonError"
            :regexpErrorIndicator="socialReasonRegexpError">
          </form-write-group-label-input>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col sm="6" class="form-group">
          <b-form-checkbox v-model="getUBOs"
            :value="true" :unchecked-value="false">
            {{ 'Récupérer les bénéficiaires effectifs' }}
          </b-form-checkbox>
        </b-col>
      </b-row> -->

      <div v-if="entities.length > 1">
        <b-row style="margin-top:10px;">
          <b-col cols="12" class="form-group">
            <span class="font-italic">
              Veuillez sélectionner un des résultats ci-dessous
            </span>
          </b-col>
        </b-row>
        <div v-for="(entity, index) in entities" :key="index"
          class="cadreCorporate" style="margin-top:10px;"
          @click="redirectDetails(entity)">
          <b-row>
            <b-col sm="4" class="h4 text-left">
              SIREN : {{ entity.SIRENUnit }}
            </b-col>
            <b-col sm="8" class="h4 text-left">
              {{ entity.Denomination }}
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4" class="h6 text-left">
              SIRET : {{ entity.SIRET }}
            </b-col>
            <b-col sm="8" class="h6 text-left">
              {{ entity.CustomAddress }}
            </b-col>
          </b-row>
          <b-row>
            <b-col class="h6 text-left" style="margin-bottom:0;">
              Activité principale : {{ entity.ActivityLabel }}
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
    <template slot="footerButtons">
      <b-row class="justify-content-start">
        <b-col md="3" offset-md="8">
          <f7-button
            class="button-action milkyBlockBlack"
            @click="verificationSend">
            {{ $t('verifications.btnSubVerification') }}
          </f7-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {errorMessageAlert} from '@/helpers/alert'
import { loadPage } from '@/helpers/routing'
import {verifyMandatoryValues, verifyRegexpValues, checkErrorFlag} from '@/helpers/validator'

export default {
  name: 'VerificationsCreateTemplate',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      entities: [],
      getUBOs: false,
      siren: '',
      sirenError: false,
      sirenRegexpError: false,
      siret: '',
      siretError: false,
      siretRegexpError: false,
      socialReason: '',
      socialReasonError: false,
      socialReasonRegexpError: false,
      vatNumber: '',
      vatNumberError: false,
      vatNumberRegexpError: false
    }
  },
  created () {
  },
  methods: {
    redirectDetails (entity) {
      entity.getUBOs = this.getUBOs
      entity.verify = true
      this.$engine.services.suppliers.selectedEntity = entity
      loadPage(this, { url: '/verifications/details/' })
    },
    validateForm () {
      let flagsList = {}
      let mandatoryValues = []
      // let mandatoryValues = ['siren']
      let regexpValues = {
        'siren': 'SIREN',
        'siret': 'SIRET'
      }
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      flagsList = verifyRegexpValues(regexpValues, flagsList, this)
      let errorFlag = checkErrorFlag(flagsList)
      return !errorFlag
    },
    verificationSend () {
      if (!this.validateForm()) {
        this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
        return
      }

      this.$f7.showPreloader(this.$i18n.t('loading.verification_loader'))

      let params = {
        CountryCode: 'FR'
      }

      let paramsContent = {
        CdAppli: 'C4',
        Entities: []
      }

      let entityToSearch = {
        LegalUnitOnly: '0',
        MaxResults: '10',
        GetInpiData: '0',
        GetInpiActs: '0'
      }

      if (this.siren) {
        entityToSearch.SIREN = {
          Rule: 'strict',
          Value: this.siren
        }
        entityToSearch.StatusOpenOnly = '0'
      }
      if (this.siret) {
        entityToSearch.SIRET = {
          Rule: 'strict',
          Value: this.siret
        }
        entityToSearch.StatusOpenOnly = '0'
      }
      if (this.socialReason) {
        entityToSearch.Name = {
          Rule: 'strict', // à remplacer par contain plus tard
          Value: this.socialReason
        }
        entityToSearch.StatusOpenOnly = '1'
      }

      paramsContent.Entities.push(entityToSearch)

      params.content = paramsContent

      let that = this
      this.$engine.services.suppliers.getLegalStatus(params)
        .then(response => {
          if (response.status === 200) {
            that.$f7.hidePreloader()
            that.entities = response.data.Response.Entities[0].Results.Establishments
            if (!that.entities) {
              alert(that.$i18n.t('errors.no_results_found_from_API'))
            } else if (that.entities.length === 1) {
              // let entity = that.entities
              let entity = response.data.Response.Entities[0].Results.Establishments[0]
              that.redirectDetails(entity)
            } else {
              for (var i = 0; i < that.entities.length; i++) {
                that.entities[i].CustomAddress = ''
                let addressElements = ['StreetNumber', 'StreetNumberRepetition', 'StreetType', 'StreetName', 'PostalCode', 'TownName']
                for (let indexElement in addressElements) {
                  let element = addressElements[indexElement]
                  if (that.entities[i][element]) {
                    if (that.entities[i].CustomAddress === '') {
                      that.entities[i].CustomAddress += that.entities[i][element]
                    } else {
                      that.entities[i].CustomAddress += ' ' + that.entities[i][element]
                    }
                  }
                }
              }
            }
          }
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
    }
  }
}
</script>

<style>
.cadreCorporate {
  background-color: white;
  border: 1px solid grey;
  cursor: pointer;
  padding: 20px;
  width: 100%;
}
.cadreCorporate:hover {
  border: 2px solid rgb(18, 188, 241);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// VerificationsCreateTemplate.vue?3e827c7c